import { render, staticRenderFns } from "./TransactionHistory.vue?vue&type=template&id=f756a4b0&scoped=true&"
import script from "./TransactionHistory.vue?vue&type=script&lang=js&"
export * from "./TransactionHistory.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHistory.vue?vue&type=style&index=0&id=f756a4b0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f756a4b0",
  null
  
)

export default component.exports